import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-click-to-scan-qr-code-stamp',
  templateUrl: './click-to-scan-qr-code-stamp.component.html',
  styleUrls: ['./click-to-scan-qr-code-stamp.component.scss'],
})
export class ClickToScanQrCodeStampComponent  implements OnInit {
  @Input() mode:'button'
  @Input() behavior:'static'|'animate'
  constructor() { }

  ngOnInit() {}

}
